import type { ComponentType } from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import {
  LAYUP_STATUS_OPTION,
  LayUpStatuses,
} from '@src/constants/LayupStatuses';

type StatusConfig = {
  Icon: ComponentType;
  color: string;
  bgColor: string;
};

const ProgressIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 0C10.5021 0 10.9091 0.407014 10.9091 0.909091V4.54545C10.9091 5.04753 10.5021 5.45455 10 5.45455C9.49792 5.45455 9.09091 5.04753 9.09091 4.54545V0.909091C9.09091 0.407014 9.49792 0 10 0Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 14.5455C10.5021 14.5455 10.9091 14.9525 10.9091 15.4545V19.0909C10.9091 19.593 10.5021 20 10 20C9.49792 20 9.09091 19.593 9.09091 19.0909V15.4545C9.09091 14.9525 9.49792 14.5455 10 14.5455Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.9299 2.9299C3.28492 2.57488 3.86053 2.57488 4.21555 2.9299L6.78828 5.50263C7.1433 5.85765 7.1433 6.43326 6.78828 6.78828C6.43326 7.1433 5.85765 7.1433 5.50263 6.78828L2.9299 4.21555C2.57488 3.86053 2.57488 3.28492 2.9299 2.9299Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2117 13.2117C13.5667 12.8567 14.1423 12.8567 14.4974 13.2117L17.0701 15.7844C17.4251 16.1395 17.4251 16.7151 17.0701 17.0701C16.7151 17.4251 16.1395 17.4251 15.7844 17.0701L13.2117 14.4974C12.8567 14.1423 12.8567 13.5667 13.2117 13.2117Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 10C0 9.49792 0.407014 9.09091 0.909091 9.09091H4.54545C5.04753 9.09091 5.45455 9.49792 5.45455 10C5.45455 10.5021 5.04753 10.9091 4.54545 10.9091H0.909091C0.407014 10.9091 0 10.5021 0 10Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5455 10C14.5455 9.49792 14.9525 9.09091 15.4545 9.09091H19.0909C19.593 9.09091 20 9.49792 20 10C20 10.5021 19.593 10.9091 19.0909 10.9091H15.4545C14.9525 10.9091 14.5455 10.5021 14.5455 10Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.78828 13.2117C7.1433 13.5667 7.1433 14.1423 6.78828 14.4974L4.21555 17.0701C3.86053 17.4251 3.28492 17.4251 2.9299 17.0701C2.57488 16.7151 2.57488 16.1395 2.9299 15.7844L5.50263 13.2117C5.85765 12.8567 6.43326 12.8567 6.78828 13.2117Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.0701 2.9299C17.4251 3.28492 17.4251 3.86053 17.0701 4.21555L14.4974 6.78828C14.1423 7.1433 13.5667 7.1433 13.2117 6.78828C12.8567 6.43326 12.8567 5.85765 13.2117 5.50263L15.7844 2.9299C16.1395 2.57488 16.7151 2.57488 17.0701 2.9299Z"
      fill="currentColor"
    />
  </svg>
);
const CheckPending = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 1.81818C5.48131 1.81818 1.81818 5.48131 1.81818 10C1.81818 14.5187 5.48131 18.1818 10 18.1818C14.5187 18.1818 18.1818 14.5187 18.1818 10C18.1818 5.48131 14.5187 1.81818 10 1.81818ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 3.63636C10.5021 3.63636 10.9091 4.04338 10.9091 4.54545V9.43815L14.0429 11.0051C14.492 11.2296 14.674 11.7757 14.4495 12.2247C14.2249 12.6738 13.6789 12.8558 13.2298 12.6313L9.59344 10.8131C9.28546 10.6591 9.09091 10.3443 9.09091 10V4.54545C9.09091 4.04338 9.49792 3.63636 10 3.63636Z"
      fill="currentColor"
    />
  </svg>
);

const MissingIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 1.81818C5.48131 1.81818 1.81818 5.48131 1.81818 10C1.81818 14.5187 5.48131 18.1818 10 18.1818C14.5187 18.1818 18.1818 14.5187 18.1818 10C18.1818 5.48131 14.5187 1.81818 10 1.81818ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.18182 6.36364C8.6839 6.36364 9.09091 6.77065 9.09091 7.27273V12.7273C9.09091 13.2294 8.6839 13.6364 8.18182 13.6364C7.67974 13.6364 7.27273 13.2294 7.27273 12.7273V7.27273C7.27273 6.77065 7.67974 6.36364 8.18182 6.36364Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8182 6.36364C12.3203 6.36364 12.7273 6.77065 12.7273 7.27273V12.7273C12.7273 13.2294 12.3203 13.6364 11.8182 13.6364C11.3161 13.6364 10.9091 13.2294 10.9091 12.7273V7.27273C10.9091 6.77065 11.3161 6.36364 11.8182 6.36364Z"
      fill="currentColor"
    />
  </svg>
);
const Default = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="31" height="31" rx="7.5" stroke="#E6E7E9" />
  </svg>
);
const Checked = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.33 2.5265C11.7184 1.80841 9.91785 1.63052 8.19688 2.01935C6.47592 2.40818 4.92674 3.3429 3.78041 4.68411C2.63408 6.02531 1.95201 7.70114 1.83592 9.46167C1.71983 11.2222 2.17595 12.9731 3.13624 14.4532C4.09654 15.9333 5.50956 17.0634 7.16457 17.6748C8.81958 18.2862 10.6279 18.3463 12.3198 17.8461C14.0118 17.3458 15.4967 16.312 16.5531 14.8989C17.6095 13.4858 18.1808 11.769 18.1818 10.0047V9.16884C18.1818 8.66676 18.5888 8.25975 19.0909 8.25975C19.593 8.25975 20 8.66676 20 9.16884V10.0052C19.9988 12.1616 19.3005 14.2604 18.0093 15.9875C16.7182 17.7147 14.9033 18.9782 12.8354 19.5896C10.7674 20.201 8.55726 20.1276 6.53447 19.3803C4.51168 18.633 2.78465 17.2518 1.61096 15.4428C0.437266 13.6338 -0.120209 11.4938 0.0216768 9.34204C0.163562 7.19029 0.997207 5.14205 2.39828 3.5028C3.79935 1.86354 5.69278 0.721106 7.79619 0.24587C9.89959 -0.229366 12.1003 -0.0119393 14.07 0.865724C14.5286 1.07007 14.7347 1.6075 14.5304 2.06611C14.326 2.52472 13.7886 2.73085 13.33 2.5265Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.7334 2.08933C20.0886 2.44418 20.0889 3.01978 19.7341 3.37498L10.6431 12.475C10.4727 12.6456 10.2414 12.7415 10.0002 12.7416C9.75905 12.7416 9.52772 12.6458 9.35718 12.4753L6.62991 9.74802C6.27489 9.393 6.27489 8.8174 6.62991 8.46238C6.98493 8.10736 7.56053 8.10736 7.91556 8.46238L9.99968 10.5465L18.4478 2.08997C18.8026 1.73477 19.3782 1.73449 19.7334 2.08933Z"
      fill="currentColor"
    />
  </svg>
);

const STATUS_CONFIG: Record<LayUpStatuses, StatusConfig> = {
  Missing: {
    Icon: MissingIcon,
    color: ' rgba(241, 67, 54, 1)',
    bgColor: ' rgba(241, 66, 54, 0.08)',
  },
  LayUpPaused: {
    Icon: MissingIcon,
    color: 'rgba(157, 165, 186, 1)',
    bgColor: 'rgba(157, 165, 186, 0.08)',
  },
  LayUpInProgress: {
    Icon: ProgressIcon,
    color: ' rgba(80, 70, 229, 1)',
    bgColor: 'rgba(80, 70, 229, 0.08)',
  },

  Checked: {
    Icon: Checked,
    color: 'rgba(0, 171, 134, 1)',
    bgColor: 'rgba(0, 171, 134, 0.08)',
  },
  CheckPending: {
    Icon: CheckPending,
    color: 'rgba(242, 162, 0, 1)',
    bgColor: 'rgba(242, 162, 0, 0.08)',
  },
  Checking: {
    Icon: Checked,
    color: 'rgba(242, 162, 0, 1)',
    bgColor: 'rgba(242, 162, 0, 0.08)',
  },
  CheckedMissing: {
    Icon: Checked,
    color: 'rgba(241, 67, 54, 1)',
    bgColor: 'rgba(241, 67, 54, 0.08)',
  },
};

type Props = {
  status?: LayUpStatuses;
  size?: number;
  translucent?: boolean;
};

function LayUpBoxIcon({ status, size = 40, translucent = false }: Props) {
  const config = status ? STATUS_CONFIG[status] : undefined;

  if (!config) {
    return <Default />;
  }

  const { Icon, color, bgColor } = config;

  return (
    <Tooltip
      title={
        !translucent && (
          <Typography variant="caption">
            {LAYUP_STATUS_OPTION[status!]}
          </Typography>
        )
      }>
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          alignSelf: 'center',
          width: size,
          height: size,
          borderRadius: '8px',
          color,
          border: `1px solid ${color}`,
          backgroundColor: bgColor,
          opacity: translucent ? 0.2 : 1,
        }}>
        <Icon />
      </Box>
    </Tooltip>
  );
}

export default LayUpBoxIcon;
